import { React, useState } from "react";

import { Collapse, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";

import { InsideDrawerNav } from "./InsideDrawerNav";

import { Routes, servicesRoutes } from "consts/Routes-App";

import { useRecoilValue } from "recoil";
import { rioNegroServices } from "recoilState/GlobalState";

import styles from "./ListDrawer.module.scss";
import { ExpandLess, ExpandMore, HomeRounded } from "@mui/icons-material";
import { Link } from "react-router-dom";

import * as iconServicios from "assets/icons/servicios";

/**
 * Fuera de esta entrega: solo se expone Programa Salud.
 *
 * El filtro va aca y no en Routes-App porque el drawer arma el menu en dos pasos:
 * primero lista los servicios que el back dice que el usuario tiene autorizados y
 * recien despues busca las rutas de cada uno. Comentar las rutas deja el servicio
 * igual en la lista, como un acordeon que se abre y no muestra nada.
 *
 * Para volver atras: sacar el filtro del `.map()` de abajo y descomentar el bloque de
 * "Usuarios globales".
 */
const SERVICIOS_VISIBLES = ["RNSALUD"];

export default function ListDrawer({ setOpen }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState({});

  const todosLosServicios = useRecoilValue(rioNegroServices);
  const services = (todosLosServicios ?? []).filter((s) =>
    SERVICIOS_VISIBLES.includes(s.servicioCod)
  );

  const handleClick = () => {
    setOpen(false);
    console.log(services)
  };

  return (
    <>
      {services && (
        <List
          aria-labelledby="nested-list-subheader"
          className={styles.root}
          component="nav"
        >
          <Link to={Routes.dashboard.route}>
            <ListItem
              className={styles.itemList}
              onClick={handleClick}
            >
              <ListItemIcon>
                <HomeRounded className={styles.iconsDrawer} />
              </ListItemIcon>
              <span className={styles.textColor}>Home</span>
            </ListItem>
          </Link>
          {services.map((service, index) => (
            service.servicioAutorizado === "Y" && (
              <span key={service.servicioCod}>
                <ListItemButton
                  className={styles.itemList}
                  onClick={() => setIsDrawerOpen({ ...isDrawerOpen, [service.servicioCod]: !isDrawerOpen[service.servicioCod] })}
                >
                  <ListItemIcon>
                    <>
                      <img
                        alt={service.servicioNombre}
                        style={{ color: isDrawerOpen ? "#FFFFFF" : "#FFFFFF" }}
                        className={styles.iconsDrawer}
                        src={iconServicios[service.servicioCod]}
                      />
                    </>
                  </ListItemIcon>
                  <ListItemText className={isDrawerOpen[service.servicioCod] ? styles.textColorSelect : styles.textColor}>
                    {service.servicioNombre}
                  </ListItemText>
                  {isDrawerOpen[service.servicioCod] ? <ExpandLess style={{ color: "#FFFFFF" }} /> : <ExpandMore style={{ color: "#FFFFFF" }} />}
                </ListItemButton>
                <Collapse in={isDrawerOpen[service.servicioCod]} timeout="auto">
                  <List component="div">
                    {
                      servicesRoutes[service.servicioCod]?.map((menu, index) => (
                        <InsideDrawerNav
                          key={index}
                          menu={menu}
                          className={styles.link}
                          handleClick={handleClick}
                          route={`servicio/${service.servicioCod}`}
                        />
                      ))
                    }
                  </List>
                </Collapse>
              </span>
            )))}
          {/* Fuera de esta entrega: solo se expone Programa Salud.
          {services.length > 0 && (
            <Link to={Routes.usuariosGlobales.route}>
              <ListItem
                className={styles.itemList}
                onClick={handleClick}
              >
                <ListItemIcon>
                  <img
                    alt={"Usuarios globales"}
                    style={{ color: isDrawerOpen ? "#FFFFFF" : "#FFFFFF" }}
                    className={styles.iconsDrawer}
                    src={iconServicios["RNPSOCIAL"]}
                  />
                </ListItemIcon>
                <span className={styles.textColor}>
                  Usuarios globales
                </span>
              </ListItem>
            </Link>
          )}
          */}
        </List>
      )}
    </>
  );
}